import { useEffect } from 'react'
import dynamic from 'next/dynamic'
import { BogoBanner } from '@mc/bogo'
import { PAGE_SOURCES, PromoExplainerModal } from '@mc/promos'
import { StaticDataProvider } from '@mc/static-data-react'
import { StickyFooter } from 'components/StickyFooter'
import { GoogleOneTap } from 'experiments/pen-3951_v2_google_email_capture/components/GoogleOneTap'
import { QuizEntryModalLoader } from 'experiments/pen-5646_v1_quiz_entry_sticky_footer/client'
import { trackProductListViewed } from 'libs/events'
import { Meta } from '../components'
import type { CategoryPageProps } from '../pageProps'
import { PageDataProvider, Hero, CategoryNavCarousel } from './components'

const BelowTheFold = dynamic(
  () => import('./components/BelowTheFold').then((m) => m.BelowTheFold),
  { ssr: false },
)

export const CategoryPage = ({
  slug,
  category,
  categories,
  subcategories,
  quizEntryModalFeaturedClasses,
}: CategoryPageProps) => {
  useEffect(() => {
    trackProductListViewed(category?.id)
  }, [category])

  if (!subcategories) {
    return null
  }

  return (
    /* StaticDataProvider is used for pen-5646_v1 experiment (QuizEntryModal) */
    <StaticDataProvider
      value={{
        quizEntryModalFeaturedClasses,
      }}
    >
      <PageDataProvider value={{ categories, slug, subcategories, category }}>
        <Meta />
        <BogoBanner className='mc-mb-2' />
        <PromoExplainerModal pageSource={PAGE_SOURCES.CATEGORY_PAGE} />
        <QuizEntryModalLoader />
        <div className='container'>
          <div className='mc-mb-6'>
            <CategoryNavCarousel />
          </div>
          <Hero />
        </div>
        <GoogleOneTap />
        <BelowTheFold />
        <StickyFooter />
      </PageDataProvider>
    </StaticDataProvider>
  )
}
